import Swal from "sweetalert2";
import HelperMixin from '../../Shared/HelperMixin.vue';
import PaginationHelper from '../../Shared/PaginationHelper.vue';

export default {
    name: 'Formulary',
    mixins: [HelperMixin],
    components: {
        PaginationHelper
    },

    async created() {
        await this.CheckLoginStatus();
        if (!this.loginDetails || !this.hasInventoryAndStockAccessUi()) {
            this.$router.replace('/Home');
            return;
        }

        await this.GetAllCategories();
        this.GetInfo();
    },

    computed: {
        totalPages() {
            return Math.ceil(this.pages / this.pageSize);
        },
        statsCards() {
            return [
                this.statCard('إجمالي أصناف القائمة النمطية', this.Statistics && this.Statistics.count, 'primary', 'ti ti-list-details'),
                this.statCard('أصناف ظاهرة في القائمة العامة', this.Statistics && this.Statistics.publicCount, 'success', 'ti ti-world'),
                this.statCard('عدد التصنيفات المستخدمة', this.Statistics && this.Statistics.categoriesCount, 'info', 'ti ti-category'),
                this.statCard('أصناف تخصصية خارج القائمة', this.Statistics && this.Statistics.outsideCount, 'warning', 'ti ti-file-alert'),
                this.statCard('قائمة الأدوية التخصصية', this.Statistics && this.Statistics.specializedListedCount, 'danger', 'ti ti-shield-check',
                    'صرفها للمريض برقم هوية'),
                this.statCard('المعروض حالياً', this.Info.length, 'secondary', 'ti ti-layout-list'),
            ];
        },
        outsideCodeSample() {
            const group = (this.Statistics && this.Statistics.outsideCodeGroup) || '9001';
            return `${group}-${new Date().getFullYear()}-0001`;
        },
        dialogTitle() {
            return this.dialogMode === 'edit' ? 'تعديل صنف نمطي' : 'إضافة صنف نمطي';
        },
        dialogSubmitLabel() {
            return this.dialogMode === 'edit' ? 'حفظ التعديلات' : 'إضافة الصنف';
        }
    },

    data() {
        return {
            pageNo: 1,
            pageSize: 20,
            pages: 0,
            Search: '',
            // 0 الكل · 1 ضمن القائمة النمطية · 2 خارجها (التخصصية)
            OutsideFilter: '0',

            ScreenTitle: 'القائمة النمطية',
            Info: [],
            Statistics: null,

            dialogMode: 'create',

            ruleForm: {
                Id: 0,
                Name: '',
                CategoriesId: '',
                BatchNumber: '',
                Descriptions: '',
                Classifection: 'GENERAL',
                Proiority: 'F',
                ShowOnPublicFormulary: true,
                RequiresExpiryDate: true,
            },
            classifectionOptions: [
                { value: 'Specialized', label: 'Specialized' },
                { value: 'GENERAL', label: 'GENERAL' },
            ],
            proiorityOptions: ['A', 'B', 'C', 'D', 'E', 'F'],

            outsideForm: {
                Name: '',
                CategoriesId: '',
                Descriptions: '',
                Proiority: 'C',
                RequiresExpiryDate: true,
            },

            importForm: {
                File: null,
                FileName: '',
                ShowOnPublicFormulary: true,
            },

            outsideRules: {
                Name: this.$helper.Required(),
                Proiority: this.$helper.Required(),
            },

            rules: {
                Name: this.$helper.Required(),
                BatchNumber: this.$helper.Required(),
                Classifection: this.$helper.Required(),
                Proiority: this.$helper.Required(),
            },
        };
    },

    methods: {
        publicBadgeClass(showOnPublicFormulary) {
            return showOnPublicFormulary ? 'bg-label-success' : 'bg-label-secondary';
        },
        expiryBadgeClass(requiresExpiryDate) {
            return requiresExpiryDate ? 'bg-label-warning' : 'bg-label-info';
        },
        formularyMeta(item) {
            if (item && item.descriptions) return item.descriptions;
            return '—';
        },
        formularyOrigin(item) {
            if (item && item.categoryName) return item.categoryName;
            return 'بدون تصنيف طبي';
        },
        /** إدارة الصيدلة ومسؤول النظام فقط — مطابق لصلاحية الخادم. */
        canEditSpecializedList() {
            return this.isAdministratorRole() || this.isMinistryPharmacyDepartmentRole();
        },

        toggleSpecializedListed(item, value) {
            this.$http.SetFormularySpecializedListed(item.id, value)
                .then((res) => {
                    item.isSpecializedListed = !!(res.data && res.data.isSpecializedListed);
                    this.$helper.ShowMessage('success', 'تم', (res.data && res.data.message) || 'تم الحفظ.');
                    if (this.Statistics) {
                        this.Statistics.specializedListedCount = Number(this.Statistics.specializedListedCount || 0) + (value ? 1 : -1);
                    }
                })
                .catch((err) => {
                    item.isSpecializedListed = !value;
                    const msg = err.response && err.response.data ? err.response.data : 'تعذّر الحفظ.';
                    this.$helper.ShowMessage('error', 'خطأ', msg);
                });
        },

        GetInfo(pageNo) {
            this.pageNo = pageNo || 1;
            if (!this.Search)
                this.$blockUI.Start();

            // «3» = قائمة الأدوية التخصصية لإدارة الصيدلة (علامة مستقلة عن «خارج القائمة»).
            const filter = Number(this.OutsideFilter) || 0;
            this.$http.GetFormulary(this.pageNo, this.pageSize, this.Search, filter === 3 ? 0 : filter, filter === 3)
                .then((response) => {
                    if (!this.Search)
                        this.$blockUI.Stop();

                    this.Info = response.data.info || [];
                    this.pages = response.data.count || 0;
                    this.Statistics = response.data.statistics || null;
                })
                .catch(() => {
                    if (!this.Search)
                        this.$blockUI.Stop();
                    this.Info = [];
                    this.pages = 0;
                    this.Statistics = null;
                });
        },

        resetRuleForm() {
            this.ruleForm = {
                Id: 0,
                Name: '',
                CategoriesId: '',
                BatchNumber: '',
                Descriptions: '',
                Classifection: 'GENERAL',
                Proiority: 'F',
                ShowOnPublicFormulary: true,
                RequiresExpiryDate: true,
            };
        },

        resetImportForm() {
            this.importForm = {
                File: null,
                FileName: '',
                ShowOnPublicFormulary: true,
            };
        },

        downloadTemplate() {
            this.$blockUI.Start();
            this.$http.DownloadFormularyTemplate()
                .then((res) => {
                    const url = window.URL.createObjectURL(new Blob([res.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', 'NationalFormularyApproved.xlsx');
                    document.body.appendChild(link);
                    link.click();
                    link.remove();
                    window.URL.revokeObjectURL(url);
                    this.$blockUI.Stop();
                })
                .catch((err) => {
                    this.$blockUI.Stop();
                    this.$helper.ShowMessage(
                        'error',
                        'تعذر التحميل',
                        err.response && err.response.data ? err.response.data : 'حدث خطأ غير متوقع'
                    );
                });
        },

        resetOutsideForm() {
            this.outsideForm = {
                Name: '',
                CategoriesId: '',
                Descriptions: '',
                Proiority: 'C',
                RequiresExpiryDate: true,
            };
        },

        openOutsideDialog() {
            this.resetOutsideForm();
        },

        submitOutsideForm() {
            this.$refs.outsideForm.validate((valid) => {
                if (!valid) {
                    this.$helper.showSwal('warning');
                    return false;
                }

                this.$blockUI.Start();
                // لا يُرسل رمز: الخادم يولّده من المجموعة المحجوزة.
                const payload = {
                    ...this.outsideForm,
                    CategoriesId: this.outsideForm.CategoriesId === '' ? null : Number(this.outsideForm.CategoriesId),
                };

                this.$http.AddOutsideFormulary(payload)
                    .then((response) => {
                        this.$blockUI.Stop();
                        this.GetInfo(this.pageNo);
                        this.resetOutsideForm();
                        this.$helper.DestroyElemntById('CloseOutsideFormularyDialog');
                        const data = response.data || {};
                        this.$helper.ShowMessage('success', 'عملية ناجحة', data.message || 'تم إنشاء البند التخصصي.');
                    })
                    .catch((err) => {
                        this.$blockUI.Stop();
                        this.$helper.ShowMessage(
                            'error',
                            'خطأ بعملية الإضافة',
                            err.response && err.response.data ? err.response.data : 'حدث خطأ غير متوقع'
                        );
                    });
            });
        },

        openCreateDialog() {
            this.dialogMode = 'create';
            this.resetRuleForm();
        },

        openEditDialog(item) {
            this.dialogMode = 'edit';
            this.ruleForm = {
                Id: item.id,
                Name: item.name || '',
                CategoriesId: item.categoriesId || '',
                BatchNumber: item.batchNumber || '',
                Descriptions: item.descriptions || '',
                Classifection: item.classifection || item.Classifection || 'GENERAL',
                Proiority: item.proiority || item.Proiority || 'F',
                ShowOnPublicFormulary: !!item.showOnPublicFormulary,
                RequiresExpiryDate: item.requiresExpiryDate !== false,
            };
        },

        submitRuleForm() {
            this.$refs.ruleForm.validate((valid) => {
                if (!valid) {
                    this.$helper.showSwal('warning');
                    return false;
                }

                this.$blockUI.Start();
                const payload = {
                    ...this.ruleForm,
                    CategoriesId: this.ruleForm.CategoriesId === '' ? null : Number(this.ruleForm.CategoriesId),
                };

                const action = this.dialogMode === 'edit'
                    ? this.$http.EditFormulary(payload)
                    : this.$http.AddFormulary(payload);

                action.then((response) => {
                    this.$blockUI.Stop();
                    this.GetInfo(this.pageNo);
                    this.resetRuleForm();
                    this.$helper.DestroyElemntById('CloseFormularyDialog');
                    this.$helper.ShowMessage('success', 'عملية ناجحة', response.data);
                }).catch((err) => {
                    this.$blockUI.Stop();
                    this.$helper.ShowMessage(
                        'error',
                        this.dialogMode === 'edit' ? 'خطأ بعملية التعديل' : 'خطأ بعملية الإضافة',
                        err.response && err.response.data ? err.response.data : 'حدث خطأ غير متوقع'
                    );
                });
            });
        },

        removeItem(id) {
            Swal.fire({
                title: 'تأكيد العملية',
                text: 'هل أنت متأكد من إزالة الصنف من القائمة النمطية؟',
                icon: 'question',
                customClass: {
                    confirmButton: 'btn btn-primary'
                },
                buttonsStyling: false,
                confirmButtonText: 'تأكيد العملية',
            }).then((result) => {
                if (!result.isConfirmed)
                    return;

                this.$blockUI.Start();
                this.$http.DeleteFormulary(id)
                    .then((response) => {
                        this.$blockUI.Stop();
                        this.$helper.ShowMessage('success', 'عملية ناجحة', response.data);
                        this.GetInfo(this.pageNo);
                    })
                    .catch((err) => {
                        this.$blockUI.Stop();
                        this.$helper.ShowMessage(
                            'error',
                            'خطأ بعملية الحذف',
                            err.response && err.response.data ? err.response.data : 'حدث خطأ غير متوقع'
                        );
                    });
            });
        },

        selectImportFile(file) {
            if (!file) {
                this.resetImportForm();
                return;
            }

            const lowerName = String(file.name || '').toLowerCase();
            if (!lowerName.endsWith('.xlsx') && !lowerName.endsWith('.xls')) {
                this.$helper.ShowMessage('error', 'خطأ بالعملية', 'يرجى اختيار ملف Excel بصيغة xlsx أو xls');
                return;
            }

            this.importForm.File = file;
            this.importForm.FileName = file.name;
        },

        submitImport() {
            if (!this.importForm.File) {
                this.$helper.ShowMessage('error', 'خطأ بالعملية', 'يرجى اختيار ملف Excel أولاً');
                return;
            }

            this.$blockUI.Start();
            this.$http.ImportFormulary(this.importForm.File, this.importForm.ShowOnPublicFormulary)
                .then(async (response) => {
                    this.$blockUI.Stop();
                    await this.GetAllCategories();
                    this.GetInfo(1);
                    this.resetImportForm();
                    this.$helper.DestroyElemntById('CloseImportDialog');

                    const result = response.data || {};
                    const warningText = (result.warnings || []).length
                        ? `\nتنبيهات: ${(result.warnings || []).join(' | ')}`
                        : '';
                    this.$helper.ShowMessage(
                        'success',
                        'تم الاستيراد',
                        `${result.message || 'تم استيراد الملف بنجاح'} | جديد: ${result.created || 0} | محدث: ${result.updated || 0} | تصنيفات جديدة: ${result.categoriesCreated || 0}${warningText}`
                    );
                })
                .catch((err) => {
                    this.$blockUI.Stop();
                    this.$helper.ShowMessage(
                        'error',
                        'فشل استيراد الملف',
                        err.response && err.response.data ? err.response.data : 'حدث خطأ غير متوقع أثناء الاستيراد'
                    );
                });
        },
    }
}
